import React from 'react'
import { AddCar } from '../conponents'
import CarForm from "../conponents/car/CarForm"


export const AddCarPage = () => <CarForm /> //<AddCar/>